module.exports = __webpack_public_path__ + "img/logo_13.bfc13498.png";